/**
 * Hanko Frontend SDK Initialization
 *
 * Configures the Hanko frontend SDK for the Survey Explorer React app.
 * Must be imported ONCE at app startup (in index.js, before App).
 *
 * REACT_APP_HANKO_URL must match what Console and Designer use, so the
 * same Hanko session JWT (cookie scoped to .samsurveyor.com) is read by
 * all three apps.
 *
 * cookieDomain MUST be set, for the same reason Console sets it. The SDK
 * writes the session cookie from JavaScript, and without this option it
 * writes it scoped to the current host. Signing out from Explorer would then
 * delete an explorer.samsurveyor.com cookie that never existed, and leave the
 * real samsurveyor.com one in the browser. The token is dead on the server
 * either way, so this is not a security hole. But the browser keeps sending a
 * dead cookie on every later request, and that reads as a broken app.
 *
 * The option is only correct on a samsurveyor.com page. A page served from
 * localhost cannot write a cookie for another domain, and asking it to means
 * no cookie is written at all. So local development gets no cookieDomain.
 */

import { Hanko } from '@teamhanko/hanko-frontend-sdk';

const HANKO_API_URL = process.env.REACT_APP_HANKO_URL || 'http://localhost:8000';

const SESSION_COOKIE_DOMAIN = 'samsurveyor.com';

/** The cookie domain to use here, or undefined when this page is not on it. */
function cookieDomainForThisHost() {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
    if (host === SESSION_COOKIE_DOMAIN || host.endsWith(`.${SESSION_COOKIE_DOMAIN}`)) {
        return SESSION_COOKIE_DOMAIN;
    }
    return undefined;
}

const cookieDomain = cookieDomainForThisHost();
const hanko = cookieDomain ? new Hanko(HANKO_API_URL, { cookieDomain }) : new Hanko(HANKO_API_URL);

export { hanko, HANKO_API_URL };
export default hanko;
